import { createRouter, createWebHistory } from 'vue-router'
import { pinia } from '@/pinia'
import { useAuthStore } from '@/stores/authStore'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import Products from '@/views/Products.vue'
import DatevReport from '@/views/DatevReport.vue'
import ShureMonthly from '@/views/ShureMonthly.vue'
import SnowflakeReports from '@/views/SnowflakeReports.vue'
import StockTake from '@/views/StockTake.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, requiresGuest: true }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: { requiresAuth: true }
  },
  {
    path: '/datev-report',
    name: 'DatevReport',
    component: DatevReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/shure-monthly',
    name: 'ShureMonthly',
    component: ShureMonthly,
    meta: { requiresAuth: true }
  },
  {
    path: '/stock-take',
    name: 'StockTake',
    component: StockTake,
    meta: { requiresAuth: true }
  },
  {
    path: '/snowflake-reports',
    name: 'SnowflakeReports',
    component: SnowflakeReports,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore(pinia)
  await authStore.initialize()

  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    return { name: 'Dashboard' }
  }

  if (to.meta.requiresAuth !== false && !authStore.isAuthenticated) {
    return {
      name: 'Login',
      query: { redirect: to.fullPath }
    }
  }

  return true
})

export default router
